import { render, staticRenderFns } from "./NewOffer.vue?vue&type=template&id=5acd513d&"
import script from "./NewOffer.vue?vue&type=script&lang=js&"
export * from "./NewOffer.vue?vue&type=script&lang=js&"
import style0 from "./NewOffer.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VTextField})
